/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { WorkCenterTasksByCategory } from '../../models/work-center-tasks-by-category';

export interface GetOpenWorkCenterTasksByCategory$Params {
  workCenterId: number;
}

export function getOpenWorkCenterTasksByCategory(http: HttpClient, rootUrl: string, params: GetOpenWorkCenterTasksByCategory$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<WorkCenterTasksByCategory>>> {
  const rb = new RequestBuilder(rootUrl, getOpenWorkCenterTasksByCategory.PATH, 'get');
  if (params) {
    rb.path('workCenterId', params.workCenterId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<WorkCenterTasksByCategory>>;
    })
  );
}

getOpenWorkCenterTasksByCategory.PATH = '/api/v1/Tasks/{workCenterId}/ByCategory';
